import React, { useEffect, useState } from 'react';
import { Modal, Tabs, message } from 'antd';
import moment from 'moment-jalaali';
import CrmSmsReport from "./CrmSmsReport"
import CrmLoginReport from './CrmLoginReport'
import CrmTicketReport from './crmTicket/CrmTicketReport'
import CrmRequestReport from '././crmRequest/CrmRequestReport';
import CrmCallHistory from './crmCallHistory/CrmCallHistory'
import CrmWallet from './crmCallHistory/CrmWallet';
import CrmUserReceipt from '../crmReport/CrmUserReceipt';
import { useGeneralStore } from '../../../store/slices/createGeneralSlice';
import { useReportsStore } from '../../../store/slices/createReportsSlice';
import ReferralReport from '../../users/ReferralReport';
import UserEndorsementReport from '../../users/UserEndorsementReport';
import UserInformationTab from '../../shared/userInformation/UserInformationTab';

moment.loadPersian();

const { TabPane } = Tabs;

export default function CrmReport({ usrUserID }) {
    const general = useGeneralStore();
    const reports = useReportsStore()
    const visible = general.view.crmReportModal;
    const [tabId, setTabId] = useState("1");
    const [category, setCategory] = useState(1);

    useEffect(() => {
        setTabId("1")
        setCategory(1)
    }, [])

    const pageSize = 10;


    function tabIdSetter(key) {

        setTabId(key);

        switch (key) {
            case "1":

                setCategory(1)
                reports.getCrmRequestReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                    CategoryPaymentStatus: 1,
                })

                break;
            case "2":
                setCategory("Ticket")
                reports.getCrmTicketReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })
                break;
            case "3":
                setCategory("Sms")
                reports.getCrmSmsReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })

                break;
            case "4":
                setCategory("Login")
                reports.getCrmLoginReport({
                    usrUserID: usrUserID,
                    PageSize: pageSize,
                    PageNumber: 1,
                })
                break;
            case "5":
                reports.getCrmWallet(usrUserID);
                setCategory("")
                break;
            case "6":
                if (usrUserID) {
                    reports.getCrmCallHistory(usrUserID)
                } else message.error("آی دی کاربر یافت نشد")
                setCategory("")
                break;
            case "7":
                reports.getUserReceipt(usrUserID);
                setCategory("")
                break;
            case "8":
                reports.getReferralReport({ param: usrUserID });
                setCategory("")
                break;
            case "9":
                reports.getUserEndorsementReport(usrUserID);
                setCategory("")
                break;
            default:
                break;
        }
    }

    return (

        <Modal
            style={{
                top: 20
            }}
            title="جزییات کاربر"
            className="custom-table crm-modal"
            open={visible}
            destroyOnClose
            footer={false}
            width="85%"
            onCancel={() => {
                general.ToggleCrmReportModal();
                setTabId("1")
                reports.clearUserInfo();
            }}>
            <div className='showBusiness-tab crm-request'>
                <Tabs
                    activeKey={tabId}
                    onChange={tabIdSetter}
                    type='card'
                    tabPosition="right"
                    destroyInactiveTabPane
                >
                    <TabPane tab="درخواست ها" key="1">
                        <CrmRequestReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                    </TabPane>
                    <TabPane tab="تیکت ها" key="2">
                        <CrmTicketReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                    </TabPane>
                    <TabPane tab="پیامک های ارسالی" key="3">
                        <CrmSmsReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                    </TabPane>
                    <TabPane tab="اطلاعات کاربر" key="info">
                        <UserInformationTab
                            userId={usrUserID}
                            active={tabId.toString() === "info"}
                        />
                    </TabPane>
                    <TabPane tab="ورود به سیستم" key="4">
                        <CrmLoginReport usrUserID={usrUserID} pageSize={pageSize} category={category} />
                    </TabPane>
                    <TabPane tab="كيف پول" key="5">
                        <CrmWallet />
                    </TabPane>
                    <TabPane tab="گزارش تماس" key="6">
                        <CrmCallHistory usrUserID={usrUserID} />
                    </TabPane>
                    <TabPane tab="رسیدهای کاربر" key="7">
                        <CrmUserReceipt usrUserID={usrUserID} />
                    </TabPane>
                    <TabPane tab="گزارش دعوت از دوستان" key="8">
                        <ReferralReport usrUserID={usrUserID} />
                    </TabPane>
                    <TabPane tab="الحاقیه ها" key="9">
                        <UserEndorsementReport userId={usrUserID} isTab={true} />
                    </TabPane>
                </Tabs>
            </div>

        </Modal>

    )
}